export const yeuCauSuaChua = {
  sections: {
    list: { title: 'Yêu cầu sửa chữa' },
    listHang: { title: 'Yêu cầu sửa chữa' },
    detail: { title: 'Chi tiết yêu cầu sửa chữa' },
    payment: { title: 'Thông tin thanh toán' },
    services: { title: 'Dịch vụ sửa chữa & thay thế' },
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  titles: { add: 'Tạo yêu cầu', edit: 'Sửa yêu cầu' },
  tabs: {
    giaoDich: 'Giao dịch',
    hangSuaChua: 'Chi tiết',
    info: 'Thông tin',
    services: 'Dịch vụ sửa chữa',
    baoCao: 'Báo cáo',
  },
  columns: {
    code: 'Mã',
    summary: 'Thông tin',
    status: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    maYeuCau: 'Mã yêu cầu',
    thoiGian: 'Thời gian',
    khachHang: 'Khách hàng',
    khachCanTra: 'Khách cần trả',
    khachDaTra: 'Khách đã trả',
    maHang: 'Mã hàng',
    tenHang: 'Tên hàng',
    serialImei: 'Serial / IMEI',
    loaiYeuCau: 'Loại yêu cầu',
    trangThaiSuaChua: 'Trạng thái SC',
    ngayHenTraKhach: 'Ngày hẹn trả',
    ngayHoanThanh: 'Ngày hoàn thành',
    tongPhi: 'Tổng phí',
    ghiChuHang: 'Ghi chú hàng',
    donGia: 'Đơn giá',
    giamGia: 'Giảm giá',
    giaBan: 'Giá bán',
    thanhTien: 'Thành tiền',
    nguoiNhan: 'Người nhận',
    noiTiepNhan: 'Nơi tiếp nhận',
    bangGia: 'Bảng giá',
    chiNhanh: 'Chi nhánh',
    soLuong: 'Số lượng',
    ghiChu: 'Ghi chú',
    note: 'Ghi chú',
    maHoaDon: 'Mã hóa đơn',
    maPhieuXuatKho: 'Mã phiếu xuất',
    ngayNhan: 'Ngày nhận',
    ngayTra: 'Ngày trả',
    nguoiNhanTra: 'Người nhận trả',
    noiDungBaoLoi: 'Nội dung báo lỗi',
    ngayBaoLoi: 'Ngày báo lỗi',
    ngayLenHoaDonLinhKien: 'Ngày lên HĐ linh kiện',
    ngayCoLinhKien: 'Ngày có linh kiện',
    tinhTrangTra: 'Tình trạng trả hàng',
    ketQuaChotKhach: 'Kết quả chốt',
    lyDoKetThuc: 'Lý do kết thúc',
    ngayTraTongHop: 'Ngày trả (đã trả đủ)',
    ngayTraTongHopHint: 'Tự tính khi toàn bộ thiết bị của phiếu đã trả — ngày và người nhận trả của lần trả cuối.',
    ngayLap: 'Ngày lập phiếu',
    model: 'Model',
    ngayChotKhach: 'Ngày chốt khách',
    ghiChuSuaChua: 'Ghi chú sửa chữa',
  },
  status: {
    dangXuLy: 'Đang xử lý',
    hoanThanh: 'Hoàn thành',
    daHuy: 'Đã hủy',
  },
  trangThai: {
    dangXuLy: 'Đang xử lý',
    hoanThanh: 'Hoàn thành',
    daHuy: 'Đã hủy',
  },
  trangThaiSuaChua: {
    daNhan: 'Đã nhận',
    dangXuLy: 'Đang xử lý',
    sanSangTraKhach: 'Sẵn sàng trả khách',
    hoanThanh: 'Hoàn thành',
  },
  loaiYeuCau: {
    suaChuaDichVu: 'Sửa chữa dịch vụ',
    yeuCauBaoHanhSP: 'Yêu cầu bảo hành SP',
    baoHanhDinhKy: 'Bảo hành định kỳ',
  },
  ketQuaChotKhach: {
    chuaChot: 'Chưa chốt',
    dongYSua: 'Đồng ý sửa',
    khongSua: 'Không sửa',
  },
  lyDoKetThuc: {
    suaXong: 'Sửa xong',
    khachKhongSua: 'Khách không sửa',
    khongCoLinhKien: 'Không có linh kiện',
    khongThayLoi: 'Không thấy lỗi',
  },
  filter: {
    searchPlaceholder: 'Tìm theo mã yêu cầu',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  filters: {
    maKhachHang: 'Mã khách hàng',
    tenKhachHang: 'Tên khách hàng',
    hintSection: 'Gợi ý',
    hintBody: 'Chọn tab để đổi view danh sách.',
    statusAll: 'Tất cả',
    maHang: 'Mã hàng',
    tenHang: 'Tên hàng',
    sectionStatus: 'Trạng thái',
    sectionStatusSC: 'Trạng thái sửa chữa',
    sectionType: 'Loại yêu cầu',
    sectionTime: 'Thời gian tạo',
    sectionTimeBaoCao: 'Thời gian',
    sectionUpdatedTime: 'Ngày cập nhật',
    sectionReturnDate: 'Hẹn trả khách',
    sectionCompletedDate: 'Ngày hoàn thành',
    sectionTrangThaiTra: 'Tình trạng trả hàng',
    sectionKetQuaChot: 'Kết quả chốt khách',
    sectionLyDoKetThuc: 'Lý do kết thúc',
    sectionGiaiDoan: 'Giai đoạn xử lý',
    sectionKyThuatVien: 'Kỹ thuật viên',
    kyThuatVienAll: 'Tất cả',
    chuaPhanCong: 'Chưa phân công',
    daTra: 'Đã trả',
    chuaTra: 'Chưa trả',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    from: 'Từ ngày',
    to: 'Đến ngày',
    allTime: 'Toàn thời gian',
  },
  form: {
    code: 'Mã yêu cầu',
    codeAuto: 'Để trống tự sinh mã',
    customer: 'Khách hàng',
    receiver: 'Người nhận',
    creator: 'Người tạo',
    createdAt: 'Thời gian tạo',
    receivePlace: 'Nơi tiếp nhận',
    noiTiepNhanCuaHang: 'Tại cửa hàng',
    noiTiepNhanTaiNha: 'Tại nhà',
    noiTiepNhanKhac: 'Khác',
    priceList: 'Bảng giá',
    note: 'Ghi chú',
    lines: 'Hàng sửa chữa',
    addLine: 'Thêm dòng',
    product: 'Hàng hóa',
    productSearch: 'Tìm mã / tên hàng',
    requestType: 'Loại yêu cầu',
    typeRepair: 'Sửa chữa dịch vụ',
    typeWarranty: 'Bảo hành SP',
    serial: 'Serial / IMEI',
    password: 'Mật khẩu thiết bị',
    matKhau: 'Mật khẩu thiết bị',
    qty: 'Số lượng',
    returnDate: 'Ngày hẹn trả',
    lineNote: 'Ghi chú hàng',
    retailCustomer: 'Khách lẻ',
    discount: 'Giảm giá',
    customerPaid: 'Khách đã trả',
    totalGoods: 'Tổng tiền hàng',
    customerMustPay: 'Khách cần trả',
    stillOwed: 'Còn cần trả',
    // POS-only fields (theo layout 1.PNG)
    customerSearch: 'Tìm khách hàng (F4)',
    serialImei: 'Serial/IMEI/Biển số',
    model: 'Model',
    modelPlaceholder: 'Nhập model máy',
    returnDatePos: 'Hẹn trả khách',
    ngayNhan: 'Ngày nhận',
    ngayTra: 'Ngày trả',
    nguoiNhanTra: 'Người nhận trả',
    ngayBaoLoi: 'Ngày báo lỗi',
    noiDungBaoLoi: 'Nội dung báo lỗi',
    ngayLenHoaDonLinhKien: 'Lên HĐ linh kiện',
    ngayCoLinhKien: 'Có linh kiện',
    ketQuaChotKhach: 'Kết quả chốt khách',
    lyDoKetThuc: 'Lý do kết thúc',
    lyDoKetThucHint: 'Chỉ chọn khi thiết bị đã Hoàn thành — để trống tự suy theo kết quả chốt',
    ngayTraHang: 'Ngày trả',
    nguoiNhanTraHang: 'Người nhận trả',
    trangThai: 'Trạng thái',
    loaiYeuCau: 'Loại yêu cầu',
    tongPhi: 'Tổng phí',
    soLuong: 'Số lượng',
    kyThuatVien: 'Kỹ thuật viên',
    ghiChuDon: 'Ghi chú đơn hàng',
    ghiChuDichVu: 'Ghi chú linh kiện / dịch vụ',
    notePlaceholder: 'Ghi chú',
    chonKyThuat: '--- Chọn ---',
    bangGiaDefault: 'Bảng giá chung',
    pickDichVu: 'Tìm hàng hóa thay thế',
    emptyDichVuHint: 'Chưa có dịch vụ / linh kiện — tìm ở ô phía trên',
    sectionThietBi: 'Thiết bị',
    sectionXuLy: 'Xử lý',
    itemExpand: 'Mở rộng',
    itemCollapse: 'Thu gọn',
    sectionBaoLoi: 'Báo lỗi & chốt',
    sectionLinhKien: 'Linh kiện & trả hàng',
    noiDungBaoLoiPlaceholder: 'Mô tả lỗi khách báo…',
    sectionDichVu: 'Hàng hóa thay thế',
    maHangCol: 'Mã hàng',
    tenHangCol: 'Tên hàng',
    ghiChuCol: 'Ghi chú',
    hinhAnhToggle: 'Thêm ảnh thiết bị',
    hinhAnhCount: '{n} ảnh',
    dichVuCount: '{n} dòng',
    customerPayment: 'Khách thanh toán',
    paymentMethod: 'Phương thức thanh toán',
    paymentCash: 'Tiền mặt',
    paymentTransfer: 'Chuyển khoản',
    paymentCard: 'Thẻ',
    paymentWallet: 'Ví',
    tienThua: 'Tiền thừa trả khách',
    conCanTra: 'Còn cần trả',
    thuKhac: 'Thu khác',
    donVi: 'ĐVT',
    donGia: 'Đơn giá',
    giaBan: 'Giá bán',
    editPrice: 'Sửa giá bán',
    discountPercent: 'Giảm (%)',
    byAmount: 'Theo số tiền',
    byPercent: 'Theo %',
    priceBelowCost: 'Giá bán đang nhỏ hơn giá vốn',
    discountCellHint: 'Nhập số tiền, hoặc thêm % để giảm theo phần trăm (vd: 10%)',
    dichVuColumnSettings: 'Ẩn / hiện cột',
    dichVuColumnReset: 'Khôi phục mặc định',
    dichVuColumnLocked: 'Cột bắt buộc, không ẩn được',
    thanhTien: 'Thành tiền',
    dichVuHangHoa: 'Hàng hóa thay thế',
    modelEmpty: 'Thiết bị sửa chữa',
    hangHoaEmpty: 'Hàng hóa sửa chữa',
    hangHoaEmptyHint: 'Tìm hàng hóa ở ô phía trên (F3) để thêm vào danh sách cần sửa.',
    pickHangHoaSua: 'Tìm hàng hóa (F3)',
    addHangHoa: 'Thêm hàng hóa mới',
    addDichVu: 'Thêm dịch vụ',
    noiTiepNhanLabel: 'Tại cửa hàng',
    save: 'LƯU',
    taoHoaDon: 'TẠO HÓA ĐƠN',
    hinhAnhHang: 'Hình ảnh hàng sửa chữa',
    hinhAnhAdd: 'Thêm ảnh',
    hinhAnhPaste: 'Dán ảnh',
    hinhAnhUploading: 'Đang tải ảnh lên',
    hinhAnhSetMain: 'Đặt làm ảnh chính',
    hinhAnhMain: 'Chính',
    hinhAnhHint: 'Tối đa 5 ảnh (ảnh đầu là ảnh chính).',
    hinhAnhDragDrop: 'Thả ảnh vào đây',
  },
  fields: {
    totalAmount: 'Tổng tiền',
    totalGoods: 'Tổng tiền hàng',
    discount: 'Giảm giá',
    customerMustPay: 'Khách cần trả',
    customerPaid: 'Khách đã trả',
    stillOwed: 'Còn cần trả',
  },
  messages: {
    loadError: 'Không tải được danh sách.',
    deleteSuccess: 'Đã xóa.',
    createSuccess: 'Đã tạo yêu cầu sửa chữa.',
    updateSuccess: 'Đã cập nhật yêu cầu.',
    needLines: 'Vui lòng thêm ít nhất một hàng sửa chữa.',
    soLuongThietBiMin: 'Số lượng thiết bị nhận phải từ 1 trở lên.',
    traTatCaChuaXong: 'Còn thiết bị chưa hoàn thành sửa chữa — không thể trả tất cả.',
    traTatCaCanNguoiNhan: 'Vui lòng chọn người nhận trả.',
    noData: 'Không có dữ liệu.',
    noLines: 'Không có dòng hàng.',
    noServices: 'Không có dịch vụ sửa chữa.',
    listSummary: 'Tổng {count} bản ghi',
    processSuccess: 'Đã bắt đầu xử lý yêu cầu.',
    taoHoaDonSuccess: 'Đã tạo hóa đơn từ yêu cầu sửa chữa.',
    taoHoaDonError: 'Tạo hóa đơn thất bại.',
    phieuXuatKhoFromRepair: 'Xuất bán theo yêu cầu sửa chữa {code}',
    completeSuccess: 'Đã kết thúc yêu cầu sửa chữa.',
    cancelSuccess: 'Đã hủy yêu cầu sửa chữa.',
    exportSuccess: 'Đã xuất file.',
    exportError: 'Xuất file thất bại.',
    printSuccess: 'Đã gửi yêu cầu in.',
    confirmCancel: 'Bạn có chắc muốn hủy yêu cầu này?',
    confirmComplete: 'Bạn có chắc muốn kết thúc yêu cầu này?',
    confirmTraHang: 'Xác nhận trả hàng cho khách?',
    traHangSuccess: 'Đã trả hàng cho khách.',
    confirmTraHangRows: 'Trả {n} thiết bị chưa trả cho khách?',
    traHangCanhBaoChuaXong: '{n} thiết bị chưa sửa xong vẫn đang được trả.',
    traHangChuaXong: 'Thiết bị chưa sửa xong vẫn trả cho khách?',
    traHangGiaTriCu: 'Hiện tại: {ngay} · {nguoi}',
    traHangOverwriteConfirm: 'Ghi đè mốc trả cũ — thao tác được ghi audit log (cũ → mới). Tiếp tục?',
    traHangXacNhanGhiDe: 'Xác nhận ghi đè',
    traHangDaTra: 'Đã trả',
    traHangThietBi: 'Trả thiết bị',
    xoaNgayTraPhieuCanhBao: 'Xóa ngày trả của phiếu sẽ xóa ngày trả của TOÀN BỘ thiết bị. Tiếp tục?',
    hinhAnhUploadError: 'Tải ảnh lên thất bại.',
  },
  actions: {
    process: 'Xử lý',
    complete: 'Kết thúc',
    cancelVoucher: 'Hủy yêu cầu',
    export: 'Xuất file',
    print: 'In',
    save: 'Lưu',
    taoPhieuXuatKho: 'Tạo phiếu xuất kho',
    traHang: 'Trả hàng',
    traTatCa: 'Trả tất cả',
    suaThongTinTra: 'Sửa thông tin trả',
  },
  placeholders: {
    formTitle: 'Tạo / sửa yêu cầu sửa chữa',
    formBody: 'Biểu mẫu đầy đủ sẽ được bổ sung theo nghiệp vụ.',
  },
  pos: {
    addTab: 'Thêm tab yêu cầu sửa chữa',
    tabTitle: 'YC sửa chữa {n}',
    tabEdit: 'Sửa {code}',
    tabClone: 'Nhái {code}',
    history: 'Lịch sử yêu cầu sửa chữa',
    confirmCloseTitle: 'Đóng tab này?',
    confirmCloseBody: 'Tab có thay đổi chưa lưu. Đóng tab sẽ mất các thay đổi chưa lưu.',
    newTabYeuCauSuaChua: 'Yêu cầu sửa chữa mới',
    openEdit: 'Mở tab sửa',
    openClone: 'Nhân bản',
    saved: 'Đã lưu yêu cầu sửa chữa.',
    status: 'Trạng thái',
    statusAll: 'Tất cả',
    statusYeuCauSuaChua: 'YC sửa chữa',
  },
  giaiDoan: {
    tatCa: 'Tất cả (trừ phiếu hủy)',
    chuaXong: 'Chưa hoàn thành',
    choKhachChot: 'Chờ khách chốt',
    dangSua: 'Đang sửa',
    khongSuaChoDong: 'Khách từ chối, chưa đóng',
    daXong: 'Đã hoàn thành',
    choTraKhach: 'Xong, chờ trả khách',
    daTra: 'Đã trả khách',
    chuaTra: 'Chưa trả khách',
    quaHan: 'Trễ hẹn trả',
  },
  baoCao: {
    thoiGian: 'Thời gian (ngày tạo phiếu)',
    duAn: 'Dự án',
    duAnHienTai: 'đang đăng nhập',
    kyThuatVien: 'Kỹ thuật viên',
    tatCaKtv: 'Tất cả kỹ thuật viên',
    khongCoKtv: 'Không tìm thấy kỹ thuật viên',
    chuaPhanCong: 'Chưa phân công',
    bieuDoTheo: 'Biểu đồ theo',
    ngay: 'Ngày',
    tuan: 'Tuần',
    thang: 'Tháng',
    kyTuan: 'Tuần {w}/{y}',
    kyThang: 'Tháng {m}/{y}',
    kyNam: 'Năm {y}',
    tyLeXong: '% hoàn thành',
    tyLeTra: '% đã trả',
    tyLeXongLine: '% hoàn thành',
    chartKtv: 'Năng suất kỹ thuật viên',
    chartKtvHint: 'SP được phân công, theo trạng thái sửa chữa',
    chartKtvTop: 'Top {n} theo số SP',
    chartKtvChuaPhanCong: '{n} SP chưa phân công',
    phamVi: '{tu} – {den} · {n} dự án',
    lamMoi: 'Làm mới',
    thuLai: 'Thử lại',
    loadError: 'Không tải được báo cáo.',
    empty: 'Không có yêu cầu sửa chữa nào trong khoảng thời gian này.',
    moDanhSach: 'Bấm để mở danh sách thiết bị',
    phieuSuaXongChuaTra: 'Chưa trả đủ',
    phieuSuaXongChuaTraHint: 'Phiếu còn ít nhất một thiết bị chưa trả',
    khacDuAnHint: 'Đang xem nhiều dự án: chỉ số liệu của dự án đang đăng nhập mới bấm mở được danh sách.',
    tongDon: 'Tổng đơn YCSC',
    tongSp: 'Tổng SP YCSC',
    daXong: 'Đã hoàn thành',
    chuaXong: 'Chưa hoàn thành',
    daTraKhach: 'Đã trả khách',
    chuaTraKhach: 'Chưa trả khách',
    choTraKhach: 'Xong, chờ trả',
    nhomSuaChua: 'Sửa chữa',
    nhomTraKhach: 'Trả khách',
    kpiTongDonSub: 'Phiếu chưa hủy · {n} dự án',
    kpiTongSpSub: 'Trung bình {n} SP/đơn',
    kpiPctSub: '{pct} tổng SP',
    kpiTreHenSub: '{n} máy trễ hẹn trả',
    kpiKhongTreHen: 'Không có máy trễ hẹn',
    kpiChuaTraSub: 'Gồm {n} máy đã xong, chờ khách lấy',
    bangTongHop: 'Tổng hợp',
    bangKtvThang: 'KTV theo tháng',
    bangTheoLoai: 'Theo loại yêu cầu',
    chiTietKtv: 'Chi tiết theo KTV',
    duAnCot: 'Dự án',
    nam: 'Năm',
    thangCot: 'Tháng',
    caThang: 'Cả tháng',
    congDuAn: 'Cộng {ten}',
    tongCong: 'Tổng cộng',
    congTong: 'Cộng tổng',
    tong: 'Tổng',
    chiSo: 'Chỉ số:',
    loaiYeuCau: 'Loại yêu cầu',
    chuaPhanLoai: 'Chưa phân loại',
    chartTienDo: 'Tiến độ theo kỳ tiếp nhận',
    chartTienDoHint: 'SP tiếp nhận trong kỳ hiện đang ở giai đoạn nào',
    chartKetQua: 'Kết quả xử lý',
    chartKetQuaHint: 'SP đã hoàn thành, theo lý do kết thúc',
    chartKetQuaEmpty: 'Chưa có SP hoàn thành',
    ketQua: {
      suaXong: 'Sửa xong',
      khachKhongSua: 'Khách không sửa',
      khongCoLinhKien: 'Không có linh kiện',
      khongThayLoi: 'Không thấy lỗi',
      chuaRoLyDo: 'Chưa ghi lý do',
    },
  },
}
